














import Widget from "@/components/common/Widget.vue";
import VerticalSingleBar from "@/components/charts/VerticalSingleBar.vue";
import DashboardItemWrapper from "@/components/DashboardItems/DashboardItemWrapper.vue";
import Vue from "vue";
import store from "@/store";
import Component from "vue-class-component";

@Component({
  components: {
    Widget,
    DashboardItemWrapper,
    VerticalSingleBar,
  },
})
export default class EBITGesamt extends Vue {
  public static id = "EBITGesamt";
  public static dprops = { width: 4, height: 4, minWidth: 2, minHeight: 2 };
  get _id() {
    return EBITGesamt.id;
  }
  get _dprops() {
    return EBITGesamt.dprops;
  }
}
